module.exports = __webpack_public_path__ + "static/media/list_darkbleu.cb9c41fe.svg";